import React, { Suspense } from 'react';

// project import
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const isChunkLoadError =
      error.name === 'ChunkLoadError' ||
      (error.message && (
        error.message.includes('ChunkLoadError') ||
        error.message.includes('Loading chunk') ||
        error.message.includes('failed to fetch')
      ));

    if (isChunkLoadError) {
      const hasReloaded = sessionStorage.getItem('chunk-load-reloaded');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-load-reloaded', 'true');
        window.location.reload();
        return;
      }
    }
    console.error('Loadable ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '24px', textAlign: 'center' }}>
          <h3>Não foi possível carregar a página.</h3>
          <p>Isso pode ocorrer devido a uma nova versão do sistema. Por favor, tente recarregar.</p>
          <button
            onClick={() => {
              sessionStorage.removeItem('chunk-load-reloaded');
              window.location.reload();
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1890ff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            Recarregar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const Loadable = (Component) => (props) => (
  <ErrorBoundary>
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  </ErrorBoundary>
);

export default Loadable;

